import { render, staticRenderFns } from "./SpeedIcon.vue?vue&type=template&id=4c43c12e&"
import script from "./SpeedIcon.vue?vue&type=script&lang=js&"
export * from "./SpeedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports